module.exports = __webpack_public_path__ + "media/images/select_rectangle-a79737fa7f0e0d591d6591f99af61778.png";